import { render, staticRenderFns } from "./AutoSelect.vue?vue&type=template&id=6bdd1c3b"
import script from "./AutoSelect.vue?vue&type=script&lang=js"
export * from "./AutoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdd1c3b')) {
      api.createRecord('6bdd1c3b', component.options)
    } else {
      api.reload('6bdd1c3b', component.options)
    }
    module.hot.accept("./AutoSelect.vue?vue&type=template&id=6bdd1c3b", function () {
      api.rerender('6bdd1c3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AutoSelect.vue"
export default component.exports